import IconImageComponent from 'components/IconImageComponent';
import intelbras_logo from '../../../assets/images/icons/devices/intelbras_logo.png';
import controlId_logo from '../../../assets/images/icons/devices/controlId_logo.png';
import hikvision_logo from '../../../assets/images/icons/devices/hikvision_logo.png';

export type BrandTypes = 'INTELBRAS' | 'CONTROLID' | 'HIKVISION';

interface BrandIconsProps {
  brand: BrandTypes;
}

const BrandIcons = ({ brand }: BrandIconsProps) => {
  switch (brand) {
    case 'CONTROLID':
      return <IconImageComponent src={controlId_logo} width={50} height={20} />;
    case 'INTELBRAS':
      return <IconImageComponent src={intelbras_logo} width={60} height={18} />;
    case 'HIKVISION':
      return <IconImageComponent src={hikvision_logo} width={50} height={20} />;
    default:
      <>{brand}</>;
  }
};

export default BrandIcons;
